import {Fragment} from 'react';
import {useTranslation} from 'react-i18next';
import {StepWizardChildProps} from 'react-step-wizard';

import {WizardFooter, TotalPrice, InputNumberWithControls} from 'components';
import {MAX_USERS_LIMIT, MIN_USERS_LIMIT} from 'constants/billing-platform';
import {TRANSLATION_KEYS} from 'locale';
import {WizardFooterProps} from 'types';
import {transformUtils} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.MAX_USERS;

type Props = {
    maxUsers: number;
    unitPrice: number;
    currency: string;
    periodUnit: string;
    wizardFooterProps: WizardFooterProps
    onUpdate: (maxUsers: number) => void;
} & Partial<StepWizardChildProps>;

export const MaxUsersStep: React.FC<Props> = ({maxUsers, unitPrice, currency, periodUnit, onUpdate, nextStep, wizardFooterProps}) => {
    const {t} = useTranslation();

    return (
        <Fragment>
            <div className='tw-text-center tw-mx-auto tw-flex -sm:tw-flex-col sm:tw-justify-center'>
                <div className='tw-mr-1'>{t(T_KEYS.LABEL)}</div>
                {`(${t(T_KEYS.UNIT_PRICE)}: ${transformUtils.formatPrice(unitPrice, currency)})`}
            </div>

            <div className='tw-flex-center tw-my-8'>
                <div className='tw-mr-8 tw-capitalize'>{t(T_KEYS.USERS)}</div>
                <InputNumberWithControls value={maxUsers} min={MIN_USERS_LIMIT} max={MAX_USERS_LIMIT} onChange={onUpdate} />
            </div>

            <TotalPrice
                className='tw-text-primary tw-text-3xl tw-text-center tw-my-8'
                unitPrice={unitPrice}
                maxUsers={maxUsers}
                periodUnit={periodUnit}
                currency={currency}
                size='large'
            />

            <WizardFooter {...wizardFooterProps} handleNext={nextStep} />
        </Fragment>
    );
};